import { render } from "./HomeSchemaJson.vue?vue&type=template&id=4d13c648"
import script from "./HomeSchemaJson.vue?vue&type=script&lang=js"
export * from "./HomeSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__